import React, { useId, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import styles from "./accordion.module.css";
import { EASE } from "../../UTILS/ANIMATION/motionVariants";

// items: [{ title, body (string | node) }]
const Accordion = ({ items, defaultOpen = 0, tone = "light", headingLevel = 3 }) => {
  const [open, setOpen] = useState(defaultOpen);
  const uid = useId();
  const Heading = `h${headingLevel}`;

  return (
    <div className={`${styles.list} ${styles[tone]}`}>
      {items.map((item, i) => {
        const isOpen = open === i;
        const btnId = `${uid}-btn-${i}`;
        const panelId = `${uid}-panel-${i}`;
        return (
          <div key={item.title} className={styles.item} data-open={isOpen}>
            <Heading className={styles.heading}>
              <button
                type="button"
                id={btnId}
                className={styles.trigger}
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => setOpen(isOpen ? null : i)}
              >
                <span className={styles.index} aria-hidden="true">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className={styles.title}>{item.title}</span>
                <span className={styles.icon} aria-hidden="true" />
              </button>
            </Heading>
            <AnimatePresence initial={false}>
              {isOpen && (
                <motion.div
                  id={panelId}
                  role="region"
                  aria-labelledby={btnId}
                  className={styles.panel}
                  initial={{ height: 0, opacity: 0 }}
                  animate={{ height: "auto", opacity: 1 }}
                  exit={{ height: 0, opacity: 0 }}
                  transition={{ duration: 0.35, ease: EASE }}
                >
                  <div className={styles.body}>{item.body}</div>
                </motion.div>
              )}
            </AnimatePresence>
          </div>
        );
      })}
    </div>
  );
};

export default Accordion;
